import PropTypes from "prop-types";
import Link from "next/link";
import { STOREPROPTYPES } from "./lib/constants";
import styles from "./styles/card.module.css";

function getStoreLink(store, isIndex) {
  let href = {
    pathname: "/stores/[slug]",
    query: { slug: store.slug.current },
  };

  if (!isIndex) {
    return <p className={styles.label}>{`${store.city}: ${store.neighbourhood}`}</p>;
  }

  return (
    <Link href={href}>
      <a className={styles.link}>{`${store.city}: ${store.neighbourhood}`}</a>
    </Link>
  );
}

export function StoreCardTitle({ isIndex, store }) {
  if (!store) {
    return null;
  }
  const wrapperStyles = `${styles.linkWrapper} ${isIndex ? styles.linkWrapperIndex : ""}`;
  return <div className={wrapperStyles}>{getStoreLink(store, isIndex)}</div>;
}

StoreCardTitle.propTypes = {
  isIndex: PropTypes.bool,
  store: STOREPROPTYPES.isRequired,
};

StoreCardTitle.defaultProps = {
  isIndex: false,
};
